module.exports = __webpack_public_path__ + "static/img/公众号二维码.26b7b22.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/公众号二维码.jpg
// module id = 1156
// module chunks = 10